var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonGlint6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 48",
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "r6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 48,
    rx: 6,
    ry: 6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glintG",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("style", null, "\n      .glint { fill: url(#glintG); mix-blend-mode: screen; transform: translateX(-40%); animation: sweep 2.4s linear infinite }\n      @keyframes sweep { to { transform: translateX(140%) } }\n      @media (prefers-reduced-motion: reduce) { .glint { animation: none } }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -8,
    width: 80,
    height: 64,
    className: "glint",
    transform: "skewX(-20)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonGlint6);
export default __webpack_public_path__ + "static/media/button-glint-6.817d20662a86e34e89d97f5a140a1891.svg";
export { ForwardRef as ReactComponent };